export const convertIntoPercentage = (
  arrayOfData: { data: number; color: string }[]
) => {
  const totalData = arrayOfData.reduce(
    (acc: number, currentData: { data: number; color: string }) => {
      return (acc += currentData.data);
    },
    0
  );
  const percentage = arrayOfData?.map((d: { data: number; color: string }) => {
    const convertNumberIntoPercentage = (d.data * 100) / totalData;
    const convertFloatToInteger = Math.ceil(convertNumberIntoPercentage);
    return {
      ...d,
      data: convertFloatToInteger ? convertFloatToInteger : 0,
    };
  });

  return percentage;
};
